// extracted by mini-css-extract-plugin
export default {"PercentBar":"PercentBar__djP02kA0TVoc","label":"label__dmOkhUwcXIlQ","progressText":"progressText__D2rusVSnMwB0","progressBar":"progressBar__V1R_Qx7aR6Ia"};